
const Api = global.Api


export default {
  jsons () {
    return Api().get('admin/metadmin/modulos/jsons')
  },
  storeJson (module, jsondata ) {
    return Api().post('admin/metadmin/modulos/jsons', {module,jsondata})
  },
  dropJson (module) {
    return Api().delete(`admin/metadmin/modulos/jsons/${module}`)
  },
  syncAll () {
    return Api().get('admin/metadmin/automap/refresh')
  },
  syncAllSQL () {
    return Api().get('admin/metadmin/autosql/query')
  },
  syncAllBuilder () {
    return Api().get('admin/metadmin/builder/gen')
  },
  
}
